module.exports = __webpack_public_path__ + "static/media/intro.d15cb02b.jpg";